module.exports = __webpack_public_path__ + "img/GHS02.51acacfb.gif";